import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemUsage } from '../../../entities/ItemUsage';
import { LoginService } from '../../../services/login.service';
import { Task } from "app/entities/Task";
import { MaintenanceObjectListConfig } from '../../../entities/enums/MaintenanceObjectListConfig';
import { MaintenanceObject } from 'app/entities/MaintenanceObject';

@Component({
  selector: 'app-modal-item-usage',
  templateUrl: './modal-item-usage.component.html',
  styleUrls: ['./modal-item-usage.component.css']
})
export class ModalItemUsageComponent implements OnInit {

  _maintenanceObjectConfiguration = MaintenanceObjectListConfig;
  public maintenanceObject: any;
  public _itemUsageToCreate: ItemUsage = { Quantity: 1 };
  public _maintenanceObjectParent: any;
  public listOfPendingMaintenanceObjects: ItemUsage[] = [];
  public isQuantityValid = true;
  public _errorMessage: string;

  @Output()
  createItemUsageEmitter = new EventEmitter()

  @Output()
  selectedConfigurationChange = new EventEmitter();

  @Output()
  oldAndNewMOEmitter = new EventEmitter<{oldMO: MaintenanceObject, newMO: MaintenanceObject}>()
  
  @Output()
  ListOfPendingMaintenanceObjectsChange = new EventEmitter<MaintenanceObject[]>()



  @Input()
  selectedConfiguration

  @Input()
  currentResourceNo: string;

  @Input()
  set MaintenanceObjectPreSelected(result: any) {
    if (result != null) {
      this._maintenanceObjectParent = result;
    }
  }

  @Input()
  showErrorMessage: boolean;

  @Input()
  set errorMessage(result: string) {
    if (result != null)
      this._errorMessage = result;
  }

  _appTaskRelation: Task;
  @Input()
  set AppTaskRelation(result: any) {
    if (result != null) {
      this._appTaskRelation = result;

      this._itemUsageToCreate.Comment = result.Title;
    }
  }
  constructor(private loginService: LoginService) { }

  ngOnInit() {
  }

  /**
   * Combines a generic UsageItem with information from given item.
   * @param object - given UsageItem
   * @returns UsageItem with new informations.
   */
  setMaintenanceObject(object: any): any {
    if (object != null) {
      let localItemUsage = this._itemUsageToCreate;
      this.maintenanceObject = object;
      localItemUsage.Item = object.Item_No;
      localItemUsage.Maintenance_Object_No = object.No;
      localItemUsage.Resource = this.currentResourceNo || this.loginService.getLoggedInUserID();
      localItemUsage.Quantity = object.Quantity;
      localItemUsage.Location_Code = object.Location_Code;
      localItemUsage.Shelf_No = object.Shelf_No;
      localItemUsage.Registered_Date_Time = new Date();
      return localItemUsage;
    }
    return null;
  }

  /**
   * Creates a UsageItem for every item in the pendingList (basket)
   */
  createItemUsage() {
    let localItemUsages: ItemUsage[] = [];

    this.listOfPendingMaintenanceObjects.forEach(o => {
      let localItemUsage: ItemUsage = Object.assign({}, this.setMaintenanceObject(o));
      if (localItemUsage) {
        localItemUsages.push(localItemUsage);
      }
    })

    if (localItemUsages)
      this.createItemUsageEmitter.emit(localItemUsages);
  }

  /**
   * Changes view to pendingList (basket)
   * Emits value of new configuration, so buttons like 'Tilbage' can be swapped
   */
  goToPendingList() {
    this.selectedConfiguration = this._maintenanceObjectConfiguration.PendingList;
    this.selectedConfigurationChange.emit(this.selectedConfiguration);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-item-usage/modal-item-usage.component.ts